import { createPortal } from "react-dom";

import CustomProcessingContent from "./CustomProcessingContent";

import styles from "./custom-processing-modal.module.scss";

const CustomProcessingModal = ({ open, message, description }) => {
	if (!open) return null;

	return createPortal(
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<CustomProcessingContent message={message} description={description} />
			</div>
		</div>,
		document.body,
	);
};

export default CustomProcessingModal;
